import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { discountConstants, discountModels } from '..';

export const usePrepaymentCalculateSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: discountModels.PrepaymentCalculate) => {
      const res = await $api.post('/v1/discount/config/prepayment-calculate', {
        calculateTime: data
      });

      return res?.data?.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries([discountConstants.queryKeys.DISCOUNT_CONFIG_PREPAYMENT_CALCULATE]);
      }
    }
  );
};
